/*
 * @Author: WLL
 * @Date: 2020-04-29 14:06:28
 * @LastEditors: WLL
 * @LastEditTime: 2020-05-01 11:40:44
 * @Description: 基础数据查询接口
 */
import http from "@/utils/http";

export default {
  async getIndustryList() {
    return await http.post("base/industry_list", {
      pageNo: 1,
      pageSize: null
    });
  },
  async getStockList(
    data = {
      pageNo: 1,
      pageSize: null
    }
  ) {
    return await http.post("base/stock_list", data);
  },
  async getAgencyList() {
    return await http.post("base/agency_list", {
      pageNo: 1,
      pageSize: 1000
    });
  },

  getLinkUrl(data) {
    return http.post("/base/external_link", data);
  }
};
